import { render } from "./LMIGeneral.vue?vue&type=template&id=7fa143b0"
import script from "./LMIGeneral.vue?vue&type=script&lang=js"
export * from "./LMIGeneral.vue?vue&type=script&lang=js"
script.render = render

export default script